import { useInputHelper, TextInput, useFormContext } from 'framework/form';
import VacancyQuestionTypeInput from 'domain/recruiting/vacancy/publication/shared/field/VacancyQuestionTypeInput';
import { transformPathForLodash } from 'validation-schema-library';
import { get, unset } from 'lodash';
import { VACANCY_QUESTION_TYPES_ALIASES } from 'domain/recruiting/vacancy/publication/shared/vacancyPublicationService';
import React, { useEffect } from 'react';
import { Grid2 as Grid } from '@mui/material';
import AdditionalVacancyQuestionOptionList from './AdditionalVacancyQuestionOptionList';
import AdditionalVacancyQuestionOption from './AdditionalVacancyQuestionOption';

const AdditionalVacancyQuestion = (props: any) => {
  const { data } = useFormContext();
  const { getSource, getRawOnChangeCallback, getValue } = useInputHelper(props);
  const onChangeCallback = getRawOnChangeCallback() || (() => {});

  const valueSource = `${getSource()}.value`;
  const typeSource = `${getSource()}.type`;
  const optionsSource = `${getSource()}.options`;

  const isOptionListVisible = get(data, transformPathForLodash(typeSource)) === VACANCY_QUESTION_TYPES_ALIASES.OPTIONS;

  useEffect(() => {
    if (!getValue()) {
      onChangeCallback({
        [getSource()]: {},
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data && !isOptionListVisible) {
      unset(data, transformPathForLodash(optionsSource));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOptionListVisible]);

  return (
    <Grid container spacing={2} sx={{ maxWidth: { lg: 'calc(50% + 8px)' } }}>
      <Grid size={{ xs: 12, md: 12 }}>
        <TextInput source={valueSource} label="Vacancy question" />
      </Grid>
      <Grid size={{ xs: 6, md: 6 }}>
        <VacancyQuestionTypeInput source={typeSource} label="Question type" />
      </Grid>
      {isOptionListVisible ? (
        <Grid size={{ xs: 12, md: 12 }}>
          <AdditionalVacancyQuestionOptionList
            source={optionsSource}
            inputTemplate={AdditionalVacancyQuestionOption}
            addText="Add option"
          />
        </Grid>
      ) : null}
    </Grid>
  );
};

export default AdditionalVacancyQuestion;
